import {FormattedMessage} from "react-intl";
import React from "react";
import {isMobileDevice} from "../../../utils/utils";

function CustomCheckbox({id, value, setValue, label, inline, labelClass, valueClass}){
    return (
            <div className={inline && " d-flex flex-row"}>
                <label style={{fontWeight: "bold"}} htmlFor={id} className={"form-label " + (inline && ` ${labelClass}`)}>
                    {label}
                </label>
                <div className={inline ? ` ${valueClass}` : (isMobileDevice() ? "ps-3" : "ps-5")}>
                    <div className="form-check form-switch">
                        <input checked={value} onChange={e => {
                            setValue(!value);
                        }} className="form-check-input" type="checkbox" role="switch"
                               id={id}/>
                    </div>
                </div>
            </div>
    )
}

export default CustomCheckbox;
